import { IonIcon } from "@ionic/react";
import React from "react";

import checkIcon from "../../assets/icons/check.svg";
import { IStudentGearBox } from "../../state";
import BoxTitle from "../../atoms/BoxTitle";

import styles from "./BoxSelectForm.module.scss";

export interface BoxSelectFormProps {
  isOpen: boolean;
  gearBoxes?: IStudentGearBox[];
  selected_box_id: number | null;
  update: (args: { [key: string]: any }) => void;
}

const BoxSelectForm = (props: BoxSelectFormProps) => {
  const gearboxes = (props.gearBoxes ?? [])
    .filter(box => box.teacher && box.teacher.id !== null) // COREの振り返りBOXは除外
    .sort((a, b) => {
      if (
        a.my_realizations_created_at === null &&
        b.my_realizations_created_at === null
      )
        return b.id - a.id;
      if (!a.my_realizations_created_at) return 1;
      if (!b.my_realizations_created_at) return -1;
      return a.my_realizations_created_at > b.my_realizations_created_at
        ? -1
        : 1;
    });

  return (
    <div className={props.isOpen ? styles.boxArea : styles.close}>
      {gearboxes.length > 0 ? (
        <ul className={styles.boxSelector}>
          {gearboxes.map(box => (
            <li
              key={box.id}
              className={styles.boxItem}
              onClick={() => {
                if (props.selected_box_id === box.id) {
                  props.update({ showBoxDropdown: false });
                  return;
                }
                props.update({ selected_box_id: box.id });
              }}
            >
              <div className={styles.boxName}>
                <BoxTitle
                  isArchived={box.is_archived}
                  nameStatus={box.name_status}
                  title={box.title}
                  wrap={false}
                />
              </div>
              <div className={styles.teacherClassWrapper}>
                {!!box.klasses.length &&
                  box.klasses.map(cls => (
                    <span key={cls.id} className={styles.class}>
                      {cls.full_name}
                    </span>
                  ))}
                <span className={styles.teacher}>{box.teacher.full_name}</span>
              </div>
              <div className={styles.checkIconWrapper}>
                {props.selected_box_id === box.id && (
                  <IonIcon icon={checkIcon} className={styles.checkIcon} />
                )}
              </div>
            </li>
          ))}
        </ul>
      ) : (
        <p className={styles.emptyState}>BOXはまだありません</p>
      )}
    </div>
  );
};

export default BoxSelectForm;
